import { createI18n } from "vue-i18n";
import translation from "@/i18n/translation.json";
import numberFormats from "@/i18n/currency.json";

export const i18n = createI18n<false>({
  legacy: false, // must set to `false`
  locale: "de-DE",
  messages: translation,
  numberFormats: numberFormats,
});

export const t = i18n.global.t.bind(i18n.global);
export const n = i18n.global.n.bind(i18n.global);

export function setI18nLocale(locale: string) {
  i18n.global.locale.value = locale;
}

export function getI18nLocale(): string {
  return i18n.global.locale.value;
}
